import React, { forwardRef } from 'react';

import { useEventListener } from '../../hooks';
import Fade from './Fade';
import { BackDropProps } from './types';

const BackDrop = forwardRef<HTMLDivElement, BackDropProps>(
  ({ open, onClick, type = 'default', ...rest }, ref) => {
    const getEventElement = () =>
      typeof document !== 'undefined' ? document : null;
    useEventListener(
      'keydown',
      (event) => {
        if (open && event.key === 'Escape') {
          if (onClick) onClick(event);
        }
      },
      getEventElement()
    );

    return (
      <Fade
        ref={ref}
        show={open}
        onClick={onClick}
        aria-hidden="true"
        tabIndex={-1}
        type={type}
        {...rest}
      />
    );
  }
);

export default BackDrop;
